import React from 'react';
import { Box, Typography } from '@mui/material';

// ── Estilos ───────────────────────────────────────────────────────────────────
// Nota: el color usa var(--primary) definido en SurveyResponse.css para
// mantener consistencia con el resto de la UI (botones, íconos, etc.).
// Se incluye un fallback hex por si el componente se usa fuera de ese CSS.
const styles = {
  container: {
    textAlign: 'center',
    padding: '1.75rem 1.5rem 1.25rem',
    marginBottom: '1.5rem',
  },
  title: {
    fontSize: 'clamp(1.25rem, 3vw, 1.7rem)',
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.2px',
    color: '#1a1a2e',
    wordBreak: 'break-word',
    // Trunca títulos largos a 2 líneas en vez de desbordar el layout
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  divider: {
    margin: '0.9rem auto 0',
    width: '48px',
    height: '3px',
    borderRadius: '2px',
    backgroundColor: 'var(--primary, #1976d2)',
  },
};

// ── Componente ────────────────────────────────────────────────────────────────
const SurveyHeader = React.memo(({ title }) => {
  // Evita renderizar un encabezado vacío (solo el divisor) si el título
  // aún no cargó o viene vacío desde Firestore.
  if (!title) return null;

  return (
    <Box sx={styles.container}>
      <Typography variant="h3" component="h1" sx={styles.title}>
        {title}
      </Typography>
      <Box sx={styles.divider} aria-hidden="true" />
    </Box>
  );
});
SurveyHeader.displayName = 'SurveyHeader';

// ─────────────────────────────────────────────────────────────────────────────
// INSTRUCCIONES DE USO EN SurveyResponse.jsx
// ─────────────────────────────────────────────────────────────────────────────
//
// <SurveyHeader title={survey.title} />

export default SurveyHeader;